module.exports = __webpack_public_path__ + "img/6.6968f7f4.jpg";